var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('iframe',{staticStyle:{"height":"50rem","width":"99%","border":"none"},attrs:{"src":`${_vm.urlApi}/g-drive`,"title":"G-Drive"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }